import { render } from "./HeroiconsOutlineScissors.vue?vue&type=template&id=24f2a0e0"
const script = {}

import exportComponent from "/www/brandsecurity_2/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlineScissors.vue"]])

export default __exports__